import React, { useEffect, useState } from 'react';
import {
  Box,
  Flex,
  Text,
  IconButton,
  FormControl,
  FormLabel,
  Input,
  Button,
  SimpleGrid,
  useDisclosure,
  VStack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Spinner,
  Center,
  Heading,
} from '@chakra-ui/react';
import { FiMenu } from 'react-icons/fi';
import AdminSidebar from './AdminSidebar';
import { apiUrl } from '../ApiUrl/ApiUrl';
import { FiEdit, FiTrash2 } from 'react-icons/fi';

function AdminFurniture() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [imageFile, setImageFile] = useState(null);
  const [categoriess, setCategoriess] = useState([]);
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [editingBook, setEditingBook] = useState(null);
  const booksPerPage = 5;
  const [selectedCategory, setSelectedCategory] = useState("");
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    if (imageFile) {
      formData.append('image', imageFile);
    }
  
    try {
      const url = editingBook ? `${apiUrl}/public/updatecloths` : `${apiUrl}/public/savecloths`;
      // const url = editingBook ? `${apiUrl}/public/updateBookById` : `${apiUrl}/public/savebook`;
      const method = editingBook ? 'PUT' : 'POST';
  
      if (editingBook) {
        formData.append('id', editingBook.id); // Include the book ID for updating
      }
  
      const response = await fetch(url, {
        method: method,
        body: formData,
      });
  
      if (response.ok) {
        alert(editingBook ? 'Product updated successfully!' : 'Product added successfully!');
        e.target.reset();
        setImageFile(null);
        setEditingBook(null); // Reset editing state
        AllBooks(); // Refresh the book list
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.message}`);
      }
    } catch (error) {
      console.error('Error adding/updating product:', error);
      alert('Check All required Fields Then Please try again later.');
    }
  };
  const AllBooks = () => {
    fetch(`${apiUrl}/public/allCloths`)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      setBooks(data.reverse());
      setLoading(false);
    })
    .catch(error => {
      console.error('Error fetching books:', error);
      setLoading(false);
    });
  }

  useEffect(() => {
    AllBooks();
  }, []);
  const handleEdit = (book) => {
    setEditingBook(book); // Set the entire book object for editing
  };
  const handleDelete = (bookId) => {
    
    fetch(`${apiUrl}/public/deleteByClothId?id=${bookId}`, {
      method: 'DELETE',
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      alert("Deleted Successfully");
      AllBooks();
      return response.json();
    })
    .catch(error => {
      console.error('There was a problem with the delete request:', error);
    });
  };
  
  // Pagination logic
  const indexOfLastBook = currentPage * booksPerPage;
  const indexOfFirstBook = indexOfLastBook - booksPerPage;
  const currentBooks = books.slice(indexOfFirstBook, indexOfLastBook);

  const totalPages = Math.ceil(books.length / booksPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  useEffect(() => {
    fetch(`${apiUrl}/public/allCategories`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch categories');
        }
        return response.json();
      })
      .then((data) => setCategoriess(data))
      .catch((error) => console.error('Error fetching categories:', error));
  }, []);
  useEffect(() => {
    // When editingBook changes, update the selected category
    if (editingBook) {
      setSelectedCategory(editingBook.searchcategory);
    }
  }, [editingBook]);
  
  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };


  const [category, setCategory] = useState("");

  useEffect(() => {
    // When editingBook changes, set the initial category value
    if (editingBook) {
      setCategory(editingBook.category);  // Set category based on editingBook
    }
  }, [editingBook]);
  
  const handleMainCategoryChange = (event) => {
    setCategory(event.target.value);  // Update the selected category
  };

  const [selectedSize, setSelectedSize] = useState("");

  const handleSizeChange = (event) => {
    setSelectedSize(event.target.value);
  };
  const [selectedColor, setSelectedColor] = useState("");

  const handleColorChange = (event) => {
    setSelectedColor(event.target.value);
  };
  const [selectedMaterial, setSelectedMaterial] = useState("");

  const handleMaterialChange = (event) => {
    setSelectedMaterial(event.target.value);
  };


  return (
<>



    <Flex h="100%" bg="gray.100">
      <AdminSidebar />
      <Box flex="1" p={4}>
        <Flex justify="space-between" align="center" bg="white" p={4} mb={4} borderRadius="md" shadow="sm">
          <IconButton icon={<FiMenu />} aria-label="Open menu" display={{ base: 'block', md: 'none' }} onClick={onOpen} />
          <Text fontSize="xl" fontWeight="bold">
            Product Management
          </Text>
        </Flex>

        <Box bg="white" p={6} borderRadius="md" shadow="sm">
          <Text fontSize="lg" fontWeight="bold" mb={4}>
            Add New Cloth
          </Text>
          
          <form onSubmit={handleFormSubmit} encType="multipart/form-data">
            <SimpleGrid columns={4} spacing={4}>
              <FormControl id="name" isRequired>
                <FormLabel>Cloth Name</FormLabel>
                <Input type="hidden" placeholder="Enter id" name="id" defaultValue={editingBook ? editingBook.id : ''}/>
                <Input type="text" placeholder="Enter cloth title" name="name" defaultValue={editingBook ? editingBook.name : ''}/>
              </FormControl>
              <FormControl id="description" >
                <FormLabel>Description</FormLabel>
                <Input type="text" placeholder="Enter description" name="description" defaultValue={editingBook ? editingBook.description : ''}/>
              </FormControl>

              <FormControl id="size" isRequired>
              <FormLabel>Select Size</FormLabel> 
              {/* <select
        id="size"
        value={selectedSize}
        onChange={handleSizeChange}
        required
        className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
        name="size"
      >
        <option value="">Choose Size</option>
        <option value="S">S</option>
        <option value="M">M</option>
        <option value="L">L</option>
        <option value="xL">xL</option>
      </select> */}
      {selectedSize === "" ? (
  <select
    id="size"
    value={selectedSize}
    onChange={handleSizeChange}
    required
    className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
    name="size"
  >
    <option value="">Choose Size</option>
    <option value="S">S</option>
    <option value="M">M</option>
    <option value="L">L</option>
    <option value="XL">XL</option>
  </select>
) : (
  <select
  id="size"
  value={selectedSize}
  onChange={handleSizeChange}
  required
  className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
  name="size"
>
  <option value="">Choose Size</option>
  <option value="S">S</option>
  <option value="M">M</option>
  <option value="L">L</option>
  <option value="XL">XL</option>
</select>
)}

              </FormControl>
              <FormControl id="color" isRequired>
              <FormLabel>Select Color</FormLabel>
          {selectedColor === "" ? (
    <select
    id="color"
    value={selectedColor}
    onChange={handleColorChange}
    required
    className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
    name="color"
  >
    <option value="">Choose Color</option>
    <option value="Black">Black</option>
    <option value="White">White</option>
  </select>
) : (
   <select
   id="color"
   value={selectedColor}
   onChange={handleColorChange}
   required
   className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
   name="color"
 >
   <option value="">Choose Color</option>
   <option value="Black">Black</option>
   <option value="White">White</option>
 </select>
)}
              </FormControl>
              <FormControl id="material" isRequired>
              <FormLabel>Select Material</FormLabel>
        {selectedMaterial === "" ? (
     <select
     id="material"
     required
     value={selectedMaterial}
     onChange={handleMaterialChange}
     className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
     name="material"
   >
     <option value="">Choose Material</option>
     <option value="Cotton">Cotton</option>
     <option value="Polyester">Polyester</option>
   </select>
) : (
  <select
  id="material"
  required
  value={selectedMaterial}
  onChange={handleMaterialChange}
  className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
  name="material"
>
  <option value="">Choose Material</option>
  <option value="Cotton">Cotton</option>
  <option value="Polyester">Polyester</option>
</select>
)}
    
              </FormControl>
              <FormControl id="image" >
                <FormLabel>Upload Image</FormLabel>
                <Input type="file" name="imageFile" accept="image/*" onChange={(e) => setImageFile(e.target.files[0])}   />
              </FormControl>
              <FormControl id="originalprice" isRequired>
                <FormLabel>Original Price</FormLabel>
                <Input type="number" step="0.01" placeholder="Enter original price" name="originalprice" defaultValue={editingBook ? editingBook.originalprice : ''}/>
              </FormControl> 
              <FormControl id="descprice" isRequired>
                <FormLabel>Discounted Price</FormLabel>
                <Input type="number" step="0.01" placeholder="Enter discounted price" name="descprice" defaultValue={editingBook ? editingBook.descprice : ''}/>
              </FormControl>
              <FormControl id="category" isRequired>
                <FormLabel>Select Category</FormLabel>
                <select name="category" value={category} onChange={handleMainCategoryChange}>
                  <option>Select Categories</option>
                  {categoriess.length > 0 ? (
                    categoriess.map((categorys) => (
                      <option key={categorys.catId} value={categorys.catId}>
                        {categorys.catName}
                      </option>
                    ))
                  ) : (
                    <option value="">No categories available</option>
                  )} 
                </select>
              </FormControl>
              <FormControl id="searchcategory" >
                <FormLabel>Select Search Category</FormLabel>
                <select name="searchcategory" value={selectedCategory} onChange={handleCategoryChange}>
                  <option>Select Search Categories</option>
                  {categoriess.length > 0 ? (
                    categoriess.map((categorys) => (
                      <option key={categorys.catId} value={categorys.catName}>
                        {categorys.catName}
                      </option>
                    ))
                  ) : (
                    <option value="">No Search categories available</option>
                  )}
                </select>
              </FormControl>
            </SimpleGrid>
            <VStack mt={4} align="stretch">
              <Button type="submit" colorScheme="teal" width="full" >
                Add Product
              </Button>
            </VStack>
          </form>
        </Box>
      </Box>

    </Flex>

    <Box p={3}>
      <Heading as="h2" size="lg" mb={4}>Cloths List</Heading>
      {loading ? (
        <Center>
          <Spinner size="sm" />
        </Center>
      ) : (
        <>
          <TableContainer>
            <Table variant="striped" colorScheme="teal">
              <Thead> 
                <Tr>
                  <Th>Name</Th>
                  <Th>Description</Th>
                  <Th>Size</Th>
                  <Th>Color</Th>
                  <Th>Material</Th>
                  <Th>Original Price</Th>
                  <Th>Discounted Price</Th>
                  <Th>Category</Th>
                  <Th>Search Category</Th>
                  </Tr>
              </Thead>
              <Tbody>
                {currentBooks.map(book => (
                  <Tr key={book.id}>         
                    <Td>{book.id}</Td>
                    <Td>{book.name}</Td>
                    <Td>{book.description}</Td>
                    <Td>{book.size}</Td>
                    <Td>{book.color}</Td>
                    <Td>{book.material}</Td>
                    <Td>{book.originalprice}</Td>
                    <Td>{book.descprice}</Td>
                    <Td>{book.searchcategory}</Td>
                    <Td>
                      <Flex gap={2}>
                        <IconButton
                          aria-label="Edit Book"
                          icon={<FiEdit />}
                          onClick={() => {
                            handleEdit(book);
                            setSelectedSize(book.size);
                            setSelectedColor(book.color); 
                            setSelectedMaterial(book.material);
                            window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to the top smoothly

                          }}
                        
                        />
                        <IconButton
                          aria-label="Delete Book"
                          icon={<FiTrash2 />}
                          colorScheme="red"
                          onClick={() => handleDelete(book.id)}
                        />
                      </Flex>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
          <Flex justify="space-between" mt={4}>
            <Button onClick={handlePreviousPage} disabled={currentPage === 1}>
              Previous
            </Button>
            <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
              Next
            </Button>
          </Flex>
        </>
      )}
    </Box>
</>
    
  );
}

export default AdminFurniture;
